import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import * as moment from 'moment';
import { Country } from '../country';
import { Gender } from '../gender';
import { HttpService } from '../service/http.service';
import { Language } from '../language';

@Component({
  selector: 'app-student-create',
  templateUrl: './student-create.component.html',
  styleUrls: ['./student-create.component.css']
})
export class StudentCreateComponent implements OnInit {

  studentForm!: FormGroup;
  languages: Language[] = [];
  genders: Gender[] = [];
  countries: Country[] = [];

  constructor(
    private httpService: HttpService,
    private builder: FormBuilder
  ) { }

  ngOnInit(): void {
    this.httpService.getLanguages().subscribe(res => this.languages = res);
    this.httpService.getGenders().subscribe(res => this.genders = res);
    this.httpService.getAllCountries().subscribe(res => this.countries = res);
    this.studentForm = this.builder.group({
      firstName: null,
      lastName: null,
      language: null,
      gender: null,
      birthday: null,
      nationality: null
    });
  }

  

}
